module.exports = __webpack_public_path__ + "static/horn_of_valhalla-d40c02d18f76a64c3996f7bdb6a85db7.jpeg";